export default __webpack_public_path__ + "static/media/img-map-background.544d7a57.jpeg";